function Error404() {
    return (
        <div className="error-404-wrapper">
            <h2> 404 </h2>
            <p> Page Not Found </p>
        </div>
    );
}

export default Error404;